import warehouse from "./warehouse.json";
import country from "./country.json";

const constant = {
  ...country,
  ...warehouse,
};

export default constant;
